// Public receiving address, not an SMTP credential. Changing it requires
// activating the new recipient with FormSubmit before relying on delivery.
export const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || 'tronicsteam@tronicsbase.com';
export const contactEndpoint = `https://formsubmit.co/ajax/${encodeURIComponent(contactEmail)}`;
export const contactReasons = [
  { value: 'custom-order', label: 'Custom order' },
  { value: 'kit-support', label: 'Kit support' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'other', label: 'Other' },
];
